export default [
  {
    title: 'Welcome',
    element: 'body',
    text: 'Welcome to Idonia, your medical image sharing platform. In this tour we will help you getting started.',
    placement: {
      relativeTo: 'viewport',
      position: 'bottom right'
    }
  },
  {
    title: 'My Space',
    element: '.file-container',
    text: 'In "My Space" you will find all your folder, documents and studies stored in Idonia. Drag here the folder or files you want to upload.',
    placement: {
      relativeTo: 'viewport',
      position: 'center center'
    }
  },
  {
    title: '"New" Button',
    element: 'button.new',
    text: 'Use this menu to create a folder, upload a file or folder from your device. You can also upload a whole DICOM study to visualize it.',
    placement: {
      relativeTo: 'element',
      position: 'left top'
    }
  },
  {
    title: 'Shared Files',
    element: 'a[data-name="shared"]',
    text: 'In "shared with me" you can see the cases that SERAM has shared with you as well as other files and folders shared by other users.',
    placement: {
      relativeTo: 'element',
      position: 'right bottom'
    }
  }
]



// WEBPACK FOOTER //
// ./src/components/common/tour/tours/desktop/en-US/seram2018.js